import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    name = '',
    orgType = 0,
    qq = '',
    email = '',
    contactPer = '',
    contactTel = '',
    mobile = '',
    province = '',
    city = '',
    county = '',
    address = '',
    industryId = '',
    password = '',

}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.org.addMySubOrg, {
        id,
        name,
        orgType,
        qq,
        email,
        mobile,
        contactPer,
        contactTel,
        province,
        city,
        county,
        address,
        industryId,
        password,
    }, options);
    if (error) return { error, status };
    return content || {};
};
